import scroller from '../scroller';
import helpers from "../../helpers";

const init = (array, coord) => {
	array.forEach((element) => {
		const t1 = gsap.timeline();
		const speed = element.dataset.parallaxSpeed ? element.dataset.parallaxSpeed : coord;

		gsap.set(element, {y: `+${speed}`});
		t1.to(element, {y: `-${speed}`});

		ScrollTrigger.create({
			animation: t1,
			trigger: element,
			start: 'top bottom',
			end: 'bottom',
			scrub: 1,
			// markers: {
			// 	startColor: 'green',
			// 	endColor: 'red',
			// },
			scroller: scroller.getElement(),
		});

		return () => {
			t1.kill();
		};
	});
};

const parallax = (parent) => {
	const lines = parent.querySelectorAll('.js-parallax');
	const cover = parent.querySelectorAll('.js-parallax-cover');
	const quote = parent.querySelectorAll('.quote.js-parallax-quote');

	if(!helpers.isMobile()) {
		init(lines, 100);
		init(cover, 75);
		init(quote, 40);
	}
};

export {parallax};
